export default __webpack_public_path__ + "static/cafe_36031-ce21fd2780389fafcacd17ff8a416f7d.png";